module.exports = __webpack_public_path__ + "static/media/bestof_1.285cd3ed.jpg";